import React from "react";

const Review = () => {
  return <div>review</div>;
};

export default Review;
